import { Icon } from '@eventbrite/eds-icon';
import { LineChart } from '@eventbrite/eds-iconography';
import { Modal } from '@eventbrite/eds-modal';
import { Button, Typography } from '@eventbrite/marmalade';
import { getStatsigStableIDFromLocalStorage } from '@eventbrite/statsig';
import React, { FunctionComponent, useState } from 'react';
import styles from './StatsigStableIDVisualizerTool.module.scss';

export const StatsigStableIDVisualizerTool: FunctionComponent = () => {
    const [isShown, setIsShown] = useState(false);
    const [isCopiedSuccessfully, setIsCopiedSuccessfully] = useState(false);
    const [copyTextTimeout, setCopyTextTimeout] =
        useState<NodeJS.Timeout | null>(null);
    const stableID = getStatsigStableIDFromLocalStorage();

    const copySuccessMsg = isCopiedSuccessfully ? (
        <Typography
            as="p"
            className={styles.statsigStableIdCopySuccessfulText}
            color="neutral-1000"
            variant="body-sm"
        >
            Copied successfully!
        </Typography>
    ) : null;

    const content = stableID ? (
        <div>
            <div className={styles.statsigStableIdTextWrapper}>
                <Typography as="h1" color="neutral-1000" variant="body-lg">
                    Stable ID:
                </Typography>
                <Typography
                    as="p"
                    className={styles.statsigStableIdText}
                    color="neutral-1000"
                    variant="body-md"
                >
                    {stableID}
                </Typography>
            </div>
            <div
                className={`eds-l-mar-top-3 ${styles.statsigStableIdCopyBtnWrapper}`}
            >
                <Button
                    onClick={() => {
                        if (copyTextTimeout) {
                            clearTimeout(copyTextTimeout);
                        }

                        navigator.clipboard.writeText(stableID);
                        setIsCopiedSuccessfully(true);

                        setCopyTextTimeout(
                            setTimeout(
                                () => setIsCopiedSuccessfully(false),
                                1000,
                            ),
                        );
                    }}
                    size="responsive"
                    variant="secondary"
                >
                    Copy to clipboard
                </Button>
                {copySuccessMsg}
            </div>
        </div>
    ) : (
        <span>Statsig not initialized</span>
    );

    return (
        <>
            <Modal
                type="aperture"
                isShown={isShown}
                title="Statsig Stable ID Visualizer"
                onClose={() => {
                    setIsShown(false);
                    setIsCopiedSuccessfully(false);
                }}
            >
                {content}
            </Modal>
            <div
                data-testid="statsig-stable-id-visualizer-button"
                role="button"
                aria-label="statsig-stable-id-visualizer-button"
                className={styles.statsigStableIdVisualizerButton}
                onClick={() => setIsShown(true)}
            >
                <Icon type={<LineChart />} />
            </div>
        </>
    );
};
